<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  @if (props?.validations?.count === 1) {
    <app-image-uploader
      [control]="formControl"
      [label]="props.label"
      [tooltip]="props.tooltip"
      [description]="props.description"
      [multiple]="props.multiple"
      [tag]="props?.tag"
      [maxSize]="props?.validations?.max"
      [maxCount]="props?.validations?.count"
      [extensionsAccepted]="props?.availableExtensions"
      [fileableType]="props?.fileableType">
    </app-image-uploader>
  } @else {
    <app-uploader
      [control]="formControl"
      [label]="props.label"
      [tooltip]="props.tooltip"
      [description]="props.description"
      [multiple]="props.multiple"
      [tag]="props?.tag"
      [maxSize]="props?.validations?.max"
      [maxCount]="props?.validations?.count"
      [extensionsAccepted]="props?.availableExtensions"
      [fileableType]="props?.fileableType">
    </app-uploader>
  }
</div>
